import {Button} from '@luminopia/react-toolbox/lib/button'
import Form, {ITheme as IFormTheme} from 'core/components/form/Form'
import TextField, {ITextFieldProps, ITheme as ITextFieldTheme} from 'core/components/form/text-field'
import {createValidator, required, minLength, match} from 'core/validation'
import * as React from 'react'
import {Field, FormProps, reduxForm, SubmitHandler} from 'redux-form'
import * as classNames from './CreateAccountForm.css'

export interface ICreateAccountFormFields {
  firstName: string
  lastName: string
  password: string
  confirmPassword: string
  registrationCode: string
}

interface ITheme extends IFormTheme {
  button?: string
  textFieldTheme?: ITextFieldTheme
}

interface IProps extends FormProps<ICreateAccountFormFields, {}, {}> {
  theme?: ITheme
}

/**
 * Registeration form intended for use with redux-form.
 */
class CreateAccountForm extends React.PureComponent<IProps, {}> {
  public render(): React.ReactElement<{}> {
    const { handleSubmit, pristine, submitting, error, theme = {} } = this.props
    const firstNameProps: ITextFieldProps = {
      label: 'First Name',
      placeholder: 'First Name',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }
    const lastNameProps: ITextFieldProps = {
      label: 'Last Name',
      placeholder: 'Last Name',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }
    const passwordProps: ITextFieldProps = {
      label: 'Password',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
      type: 'password'
    }
    const confirmPasswordProps: ITextFieldProps = {
      label: 'Confirm Password',
      placeholder: 'Confirm Password',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
      type: 'password'
    }
    const registrationCodeProps: ITextFieldProps = {
      type: 'hidden',
      label: 'Registration Token',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }

    const formTheme: IFormTheme = {
      error: theme.error,
    }

    return (
      <Form onSubmit={handleSubmit} error={error} theme={formTheme}>
        <Field name='firstName' component={TextField} props={firstNameProps}/>
        <Field name='lastName' component={TextField} props={lastNameProps}/>
        <Field name='password' component={TextField} props={passwordProps}/>
        <Field name='confirmPassword' component={TextField} props={confirmPasswordProps}/>
        <Field name='registrationCode' component={TextField} props={registrationCodeProps}/>
        <Button
          className={classNames.button}
          icon='check'
          disabled={pristine || submitting}
          raised primary
          onClick={handleSubmit}
        >
        </Button>
      </Form>
    )
  }
}

export default CreateAccountForm

/**
 * Component factory for creating forms, intended for use with redux-form.
 *
 * @param formName key to where your form's state will be mounted under the redux-form reducer
 * @param onSubmit fn called when prop `handleSubmit` is fired
 */
export const createAccountFormFactory = (
  {
    formName,
    registrationCode,
    onSubmit,
  }: {
    formName: string,
    registrationCode: string,
    onSubmit: SubmitHandler<ICreateAccountFormFields, {}, {}>,
  },
) => {
  const initialValues: ICreateAccountFormFields = {
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    registrationCode
  }

  const formDecorator = reduxForm<ICreateAccountFormFields, {}, {}>({
    form: formName,
    initialValues,
    onSubmit,
    validate: createValidator({
      firstName: [required],
      lastName: [required],
      password: [required, minLength(8)],
      registrationCode: [required],
      confirmPassword: [required, match<ICreateAccountFormFields>('password', 'Password')],
    }),
  })

  return formDecorator(CreateAccountForm)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/register/CreateAccountForm.tsx